import axios from 'axios';
import { isLoggedIn } from '../auth';

/**
* Fetches all available careers
* @returns {Promise} response - a promise of careers to be resolved
*/
export function getCareers() {
	if (isLoggedIn()) {
		return axios.get('/v1/careers');
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
* seloects a career for user
* @param {Number} id - id of user
* @param {Object} data - an object career selected
* @returns {Promise} response - a promise of career selected
*/
export function selectCareer(id, data) {
	if (isLoggedIn()) {
		return axios.post(`/v1/users/${id}/careers`, data);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
* Fetches all available career categories
* @returns {Promise} response - a promise of career  categories to be resolved
*/
export function getAllCategories() {
	if (isLoggedIn()) {
		return axios.get('v1/categories?status=all');
	}
	
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

export function getCategoryCareers(id) {
	if (isLoggedIn()) {
		return axios.get(`v1/categories/${id}`);
	}
	
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}